export default "__VITE_ASSET__DJXBwex9__"